import { availableRequirementValidators } from '../../../constants/availableRequirementValidators';
import { MINIMUM_LENGTH } from '../../../constants/passwordRequirementParameters';
export const hintErrors = {
    [availableRequirementValidators.HAS_UPPER_LETTER]: 'Must have at least 1 upper case letter',
    [availableRequirementValidators.HAS_LOWER_LETTER]: 'Must have at least 1 lower case letter',
    [availableRequirementValidators.HAS_NUMBERS]: 'Must have at least 1 number',
    [availableRequirementValidators.HAS_MINIMUM_LENGTH]: `Has to be at least ${MINIMUM_LENGTH} characters`,
};
